// extracted by mini-css-extract-plugin
export default {"short_title":"About_short_title__rj1e+","main_title":"About_main_title__kLxoZ","aboutceo":"About_aboutceo__eB1U6"};